module.exports = __webpack_public_path__ + "img/common-file-empty-alternate.cc4dc054.svg";